import { useState, useEffect } from 'react'
import { isApiOffline } from '../lib/api'

// Combines browser online/offline events with app-level API reachability events.
export function useOffline(): boolean {
  // Seeded from BOTH signals. navigator.onLine alone is wrong twice over: a
  // phone can hold a cellular association with no data path (it reports
  // online), and the app-offline event only fires on a transition, so a
  // component mounting after that transition would never hear about it.
  const [isOffline, setIsOffline] = useState(() => !navigator.onLine || isApiOffline())

  useEffect(() => {
    const onOnline    = () => setIsOffline(false)
    const onOffline   = () => setIsOffline(true)
    const onAppOnline  = () => setIsOffline(false)
    const onAppOffline = () => setIsOffline(true)

    window.addEventListener('online',       onOnline)
    window.addEventListener('offline',      onOffline)
    window.addEventListener('app-online',   onAppOnline)
    window.addEventListener('app-offline',  onAppOffline)

    return () => {
      window.removeEventListener('online',       onOnline)
      window.removeEventListener('offline',      onOffline)
      window.removeEventListener('app-online',   onAppOnline)
      window.removeEventListener('app-offline',  onAppOffline)
    }
  }, [])

  return isOffline
}
